import { render, staticRenderFns } from "./ViewAdminSetting.vue?vue&type=template&id=be1b3626&scoped=true"
import script from "./ViewAdminSetting.vue?vue&type=script&lang=ts"
export * from "./ViewAdminSetting.vue?vue&type=script&lang=ts"
import style0 from "./ViewAdminSetting.vue?vue&type=style&index=0&id=be1b3626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b3626",
  null
  
)

export default component.exports